import { wishlistEvent } from 'snippets/wishlist/selected'

/**
 * This is the event listener for the wishlist added event
 * @param {CustomEvent} element - The event object
 */
const wishListEventListener = async (element) => {
  setTimeout(() => {
    const getItemId = (storedItemString) => {
      try {
        const [id, _] = storedItemString.split(':')
        return id
      } catch (error) {
        console.error('Error getting item id', error)
        return null
      }
    }

    const findProductDetailsFromDatalayer = (itemId, lookupDataLayerEvent) => {
      const productDetails = window.BCDataLayerManager?.utils?.findInDataLayer(itemId, null, lookupDataLayerEvent)
      return productDetails
    }
    const wishlistItem = element.detail
    const lookUpEvents = ['view_item_list', 'view_item']
    // Lookup for the product details in the datalayer for both view_item_list and view_item
    lookUpEvents.forEach((lookupDataLayerEvent) => {
      const itemId = getItemId(wishlistItem)
      if (!itemId) {
        return
      }
      const productDetails = findProductDetailsFromDatalayer(parseInt(itemId), lookupDataLayerEvent)
      if (productDetails) {
        const payload = {
          currency: window.BCDataLayerManager?.manager?.site?.getData()?.currency || 'AUD',
          save: {
            value: productDetails.price,
            items: [
              {
                ...productDetails
              }
            ]
          }
        }
        // Push the event to the datalayer
        window.BCDataLayerManager?.manager?.eventNotification?.pushEcommerceEvent('save_product', payload)
      }
    })
  }, 100)
}

/**
 * This is the event listener for the wishlist added event for both view_item_list and view_item
 * @param {CustomEvent} element - The event object
 */
document.addEventListener(wishlistEvent.WISHLIST_ADDED, wishListEventListener)

/**
 * The FitClub signup modal's open button (account-portal-trigger.liquid) just
 * toggles a data attribute via modal.js's generic handleShow - it doesn't
 * dispatch any event we could hook into - so this listens for the click
 * directly via its data-gtm attribute instead.
 *
 * Guarded behind a window flag: this theme's webpack build has no shared
 * chunk across entry points, so a module reused by more than one bundle runs
 * its top-level code once per bundle, which would otherwise register this
 * listener more than once and double-push on a single click.
 */
const ACCOUNT_SIGNUP_MODAL_TRIGGER_SELECTOR = '[data-gtm="account_signup_modal_open"]'

if (!window.__bcAccountModalTrackingBound) {
  window.__bcAccountModalTrackingBound = true

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(ACCOUNT_SIGNUP_MODAL_TRIGGER_SELECTOR)
    if (!trigger) return

    window.BCDataLayerManager?.manager?.push('account_signup_modal_open', {
      location: trigger.getAttribute('data-gtm-location') || undefined
    })
  })
}

/**
 * Login completion signal: both OmneoPortal#mobileLogin and #sendLoginEmail
 * (AccountSignUp.js) redirect the browser back to the site with a ?token=
 * query param once the customer is authenticated. This previously lived in
 * account-portal.liquid's has_token check, but that snippet is never rendered
 * anywhere in the theme - only account-portal-trigger.liquid (a different
 * file) is actually included, from site-header.liquid/footer-signup.liquid -
 * so it never ran. Moved here since this file is confirmed to load globally.
 *
 * Pushed via raw window.dataLayer rather than manager.push(), since this runs
 * at page load before we can guarantee the pixel bundle has executed yet -
 * if it hasn't, manager.push() would silently drop the event entirely.
 * Reading the prefix directly off window._BCDataLayer.config degrades to an
 * unprefixed event instead of losing it if that isn't ready either.
 *
 * Guarded the same way as above, in case this file also ends up compiled
 * into more than one entry bundle.
 */
if (!window.__bcLoginCompletionTracked && new URLSearchParams(window.location.search).has('token')) {
  window.__bcLoginCompletionTracked = true

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: (window._BCDataLayer?.config?.eventPrefix || '') + 'login' })
}
